import { useState } from 'react';
import { Typography, Button, Tag, Input, Modal, DatePicker } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import styles from './user-assignments.module.scss';

export const UserAssignments = ({
  assignOpen,
  toggleAssign,
  user,
  addSchoolAssignment,
  deleteSchoolAssignment,
  loading,
}) => {
  const [schoolId, setSchoolId] = useState('');
  const [date, setDate] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState(null);

  const onDateChange = (date) => {
    setDate(date);
  };

  const handleAddSchool = async () => {
    await addSchoolAssignment({
      schoolId,
      userId: user.user_id,
      status: 'active',
      beginAt: date,
    });

    // Reset form
    setSchoolId(null);
    setDate(null);
  };

  const handleRemove = async (school) => {
    if (!school) {
      setConfirmOpen(false);
      return;
    }

    await deleteSchoolAssignment({
      assignmentId: school.assignment_id,
      userId: user.user_id,
      beginAt: school.begin_at,
    });

    setConfirmOpen(false);
  };

  const openConfirmModal = (e, school) => {
    e.preventDefault();

    setSelectedSchool(school);
    setConfirmOpen(true);
  };

  const schools = user?.schools.filter((school) => school.status === 'active') || [];

  return (
    <>
      <Modal
        title={`Manage Schools for ${user?.user}`}
        open={assignOpen}
        onCancel={toggleAssign}
        footer={null}
        width={800}>
        <div>
          <Typography.Paragraph className={styles.description}>
            Assign schools enter the School ID.
          </Typography.Paragraph>

          {/* Individual School Assignment */}
          <div className={styles.assignmentForm}>
            <Input
              placeholder="Enter Schola ID (e.g. 27001)"
              value={schoolId}
              onChange={(e) => setSchoolId(e.target.value)}
              className={styles.schoolInput}
            />
            <DatePicker value={date} onChange={onDateChange} />
            <Button
              type="primary"
              loading={loading}
              onClick={handleAddSchool}
              disabled={!schoolId || !date}
              className={styles.assignButton}>
              Assign School
            </Button>
          </div>

          {/* Assigned Schools Section */}
          <div className={styles.schoolsSection}>
            <Typography.Title level={5} className={styles.schoolsSectionTitle}>
              Assigned Schools:
            </Typography.Title>

            {schools?.length === 0 ? (
              <span>No schools assigned yet.</span>
            ) : (
              <div>
                {schools?.map((school) => (
                  <Tag
                    key={school.school_id}
                    className={styles.schoolTag}
                    bordered={false}
                    closeIcon={<DeleteOutlined />}
                    onClose={(e) => openConfirmModal(e, school)}>
                    {school.school_name} ({school.school_id})
                    <EditOutlined className={styles.editIcon} />
                  </Tag>
                ))}
              </div>
            )}
          </div>
        </div>
      </Modal>

      <Modal
        title="Confirm Deletion"
        open={confirmOpen}
        onCancel={() => setConfirmOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setConfirmOpen(false)}>
            Cancel
          </Button>,
          <Button key="confirm" type="primary" danger loading={loading} onClick={() => handleRemove(selectedSchool)}>
            Confirm
          </Button>,
        ]}>
        <p>
          Are you sure you want to remove{' '}
          {selectedSchool
            ? typeof selectedSchool === 'object' && selectedSchool?.school_name
              ? selectedSchool.school_name
              : `School ID: ${selectedSchool}`
            : ''}{' '}
          from this user?
        </p>
      </Modal>
    </>
  );
};
